import { isHomologation, isLocalhost } from '@/lib/env';

export type DynamicsEnvironment = 'hml' | 'prd';

// A tela de Configurações da Sessão só existe em localhost e homologação. O ambiente do ERP Dynamics das consultas é uma
// configuração GLOBAL gravada no banco (system_configuration, chave dynamics.environment; API: GET/PUT
// /system-configuration/dynamics-environment, qualquer usuário autenticado). Em produção é sempre PRD.
export const canOverrideDynamicsEnvironment = isLocalhost || isHomologation;
